import { AxiosReportLas } from '../config';

export const DocumentsService = {
  getDocs: (
    {
      nome,
      empresa,
      dataEmissaoInicio,
      dataEmissaoFim,
      dataVencimentoInicio,
      dataVencimentoFim,
      tipo,
      sistema,
      usuario,
      status,
      Unidade,
    },
    signal,
  ) => {
    return AxiosReportLas({
      method: 'get',
      url: '/v1/Documento',
      params: {
        Unidade,
        nome,
        empresa,
        dataEmissaoInicio,
        dataEmissaoFim,
        dataVencimentoInicio,
        dataVencimentoFim,
        tipo,
        sistema,
        usuario,
        status,
      },
      headers: {
        'content-type': 'application/json',
      },
      signal,
    });
  },
  createDoc: ({
    empresa,
    tipo,
    sistemaEmpresa,
    usuario,
    unidade,
    area,
    equipamento,
    nome,
    descricao,
    dataEmissao,
    dataVencimento,
    arquivo,
    inativo,
    foto,
  }) => {
    return AxiosReportLas({
      method: 'POST',
      url: 'v1/Documento',
      data: {
        empresa,
        tipo,
        sistemaEmpresa,
        usuario,
        unidade,
        area,
        equipamento,
        nome,
        descricao,
        dataEmissao,
        dataVencimento,
        arquivo,
        inativo,
        foto,
      },
      headers: {
        'content-type': 'application/json',
        Empresa: empresa,
      },
    });
  },
  getDocById: ({ id, empresa }) => {
    return AxiosReportLas({
      method: 'GET',
      url: `v1/Documento/${id}/completo`,
      params: {
        empresa,
      },
      headers: {
        'content-type': 'application/json',
        Empresa: empresa,
      },
    });
  },
  deleteDocRevision: ({ documentoId, revisaoId, empresa }) => {
    return AxiosReportLas({
      method: 'delete',
      url: `v1/Documento/${documentoId}/revisoes/${revisaoId}?empresa=${empresa}`,
      headers: {
        'content-type': 'application/json',
        Empresa: empresa,
      },
    });
  },
  saveEditedDoc: ({ data, id, empresa }) => {
    return AxiosReportLas({
      method: 'put',
      url: `v1/Documento/${id}/avancado`,
      data,
      headers: {
        'content-type': 'application/json',
        Empresa: empresa,
      },
    });
  },
  deleteDoc: ({ id, empresa }) => {
    return AxiosReportLas({
      method: 'delete',
      url: `v1/Documento/${id}?empresa=${empresa}`,
      headers: {
        'content-type': 'application/json',
        Empresa: empresa,
      },
    });
  },
};
